"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var SzTypographie_1 = require("../SzTypographie/SzTypographie");

require("./SzCardBubble.scss");

var SzCardBubble = function SzCardBubble(_a) {
  var background = _a.background,
      backgroundColor = _a.backgroundColor,
      contentBackgroundColor = _a.contentBackgroundColor,
      border = _a.border,
      children = _a.children,
      className = _a.className,
      icon = _a.icon,
      _b = _a.iconBackgroundColor,
      iconBackgroundColor = _b === void 0 ? '#ffffff' : _b,
      title = _a.title,
      titleSmall = _a.titleSmall,
      titleThin = _a.titleThin,
      _c = _a.small,
      small = _c === void 0 ? false : _c,
      subtitle = _a.subtitle,
      _d = _a.subtitlePosition,
      subtitlePosition = _d === void 0 ? 'top' : _d;
  var cardBubbleClasses = classnames_1.default('sz-card-bubble', className);
  var titleClasses = classnames_1.default('sz-card-bubble-header-title px-3 px-lg-4 pb-3', {
    'd-flex flex-column-reverse justify-content-end': subtitlePosition === 'bottom'
  });
  var headerRight = classnames_1.default({
    'sz-card-bubble-header-right': !small,
    'sz-card-bubble-header-right--small': small
  });
  var contentClasses = classnames_1.default('sz-card-bubble-content', {
    'content-border': border
  });
  var bubbleClasses = classnames_1.default('bubble d-flex align-items-center justify-content-center', {
    'bubble--small': small
  });

  var getStyleBackground = function getStyleBackground(backgroundColor) {
    return {
      backgroundColor: backgroundColor
    };
  };

  var cardBubbleStyle = getStyleBackground(backgroundColor);
  var cardBubbleIconStyle = getStyleBackground(iconBackgroundColor);
  var contentStyle = contentBackgroundColor ? getStyleBackground(contentBackgroundColor) : cardBubbleStyle;
  return react_1.default.createElement("div", {
    className: cardBubbleClasses
  }, background && react_1.default.createElement("div", {
    className: "sz-card-bubble-background",
    style: {
      backgroundImage: "url(" + background + ")"
    }
  }), react_1.default.createElement("div", {
    className: "sz-card-bubble-header"
  }, react_1.default.createElement("div", {
    className: titleClasses
  }, subtitle && react_1.default.createElement(SzTypographie_1.SzTypographie, {
    variant: "caption",
    size: "M",
    className: "",
    color: 'disabled'
  }, subtitle), react_1.default.createElement(SzTypographie_1.SzTypographie, {
    variant: "H3",
    size: titleSmall ? 'M' : subtitle ? 'S' : 'L',
    className: "m-0",
    weight: titleThin ? 'medium' : 'bold'
  }, title)), react_1.default.createElement("div", {
    className: "sz-card-bubble-header-left",
    style: cardBubbleStyle
  }), react_1.default.createElement("div", {
    className: "sz-card-bubble-header-bg-horizontal",
    style: cardBubbleStyle
  }), react_1.default.createElement("div", {
    className: headerRight,
    style: cardBubbleStyle
  }, react_1.default.createElement("svg", {
    width: "0",
    height: "0"
  }, react_1.default.createElement("clipPath", {
    id: "hole"
  }, react_1.default.createElement("path", {
    d: "M-1 0H23.5C28.1 0 32.6 2 35.6 5.6L42.7 13.8C61.9 36 96.3 36 115.4 13.8L122.5 5.6C125.6 2 130 0 134.7 0 146.9 0 156.4 0 184 0V79H-1V0Z"
  }))), react_1.default.createElement("svg", {
    width: "0",
    height: "0"
  }, react_1.default.createElement("clipPath", {
    id: "hole_small"
  }, react_1.default.createElement("path", {
    d: "M-0 0h42.2c4.9 0 9.4 2.8 11.6 7.2 14.3 28.7 55 28.7 69.3 0 2.2-4.4 6.7-7.2 11.6-7.2H183v79.5H0V0Z"
  })))), react_1.default.createElement("div", {
    className: bubbleClasses,
    style: cardBubbleIconStyle
  }, icon)), react_1.default.createElement("div", {
    className: contentClasses,
    style: contentStyle
  }, children));
};

exports.default = SzCardBubble;